export default __webpack_public_path__ + "static/media/national-life-group-logo2.d43874dd.png";